import React, { useState } from "react";
import { Form, Container, Button, Row, Col } from "react-bootstrap";
import i18n from "../constants/i18n";
import PopUp from './PopUp';

export default props => {
  let sha512 = require('js-sha512');
  const key = 'rjgW3pujKeBbThP5Z35cGMz9pkK6bbZsrWLEdKyu';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  let today = new Date();
  const day = today.getDate().toString().length === 1 ? `0${(today.getDate())}` : `${(today.getDate())}`;
  const month = (today.getMonth() + 1).toString().length == 1 ? `0${(today.getMonth() + 1)}` : `${(today.getMonth() + 1)}`;
  const year = today.getFullYear().toString();
  const hour = today.getHours().toString().length === 1 ? `0${today.getHours()}` : `${today.getHours()}`;
  const dmYH = day + month + year + hour;
  const code = sha512(key + dmYH);

  const [ForgotPasswd, setForgotPasswd] = useState(false);


  const [EmailReset, setEmailReset] = useState('');
  const [Message, setMessage] = useState('');

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   let today = new Date(); 
  //   const day= today.getDate().toString();
  //   const month = (today.getMonth() + 1).toString().length == 1 ? `0${(today.getMonth() + 1)}` : `${(today.getMonth() + 1)}`
  //   const year = today.getFullYear().toString();
  //   const hour = today.getHours().toString();
  //   const dmYH = day+ month + year + hour;
  //   const code = sha512(key + dmYH);
  //   //console.log(sha512.hmac(key, dmYH));

  //   fetch('https://ddp.systems/login/extended',{ //https://ddp.systems/login/extended

  //         method:'post',

  //         headers:{
  //           'Accept': 'application/json',
  //           'Content-Type': 'application/json',
  //         },

  //         body:JSON.stringify({
  //           email,
  //           password,
  //           code,
  //         })

  //       })
  //       .then(res=>res.json())
  //       .then(data =>{
  //         console.log('sent request')
  //         console.log(data);
  //       })
  //       .catch(error =>{
  //         console.log("Error", error)
  //       })
  // }

  const Login = () => {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    fetch('https://ddp.systems/api/public/login', {
      method: 'post',
      body: formData,

    })
      .then(data => {
        if (data.status === 201) {
          return data.json();
        } else {
          throw Error('Invalid password or email');
        }
      })
      .then(data => {
        const { loginCode } = data;
        window.location.replace(`https://ddp.systems/login/extended?email=${email}&code=${code}&loginCode=${loginCode}`)
      })
      .catch(error => {
        setMessage(error.message);
      })
  }

  const ResetPassword = () => {
    const formData = new FormData();
    formData.append('email', EmailReset);

    fetch('https://ddp.systems/api/public/reset-password', {
      method: 'post',
      body: formData,
    })
      .then(data => {
        if (data.status === 200) {
          return data.json();
        }
        else if (data.status === 401) {
          throw Error("Invalid email");
        }
        else if (data.status === 403) {
          throw Error("Reset email already sent");
        }
      })
      .then(data => {
        setMessage(data.message);
      })
      .catch(error => {
        // console.log(error);
        setMessage(error.message);
      })

  }





  return (
    <Row
      style={{
        borderRadius: "0.5rem",
        border: "1px solid rgba(0,0,0,0.1)",
        boxShadow: "0px 30px 40px 0px rgba(0,0,0,0.12)",
        background: "white",
        maxWidth: "460px",
      }}
    >
      <Col xs={12}>
        {/* <Form
          style={{ margin: "1rem", marginTop: "2rem" }}
          onSubmit = {handleSubmit}
        > */}
        <Row>
          <Col xs={12}>
            {/* <Form.Group controlId="formBasicEmail">
                <Form.Control
                  style={{ boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.1)" }}
                  type="email"
                  placeholder="Email"
                  onChange={e => setEmail(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formBasicPassword">
                <Form.Control
                  style={{ boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.1)" }}
                  type="password"
                  placeholder="Password"
                  onChange={e => setPassword(e.target.value)}
                />
              </Form.Group> */}
              {Message !== '' ? <p style={{ textAlign: 'center', margin: '0px', color: 'red', marginTop: '10px'}}>{ Message }</p> : null}
            {
              ForgotPasswd ?
                (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '370px',
                      margin: 'auto',
                    }}
                  >
                    <input type='text' name='email' placeholder='email'
                      style={{
                        height: 'calc(1.5em + .75rem + 2px)',
                        padding: '.375rem .75rem',
                        marginTop: '2.5rem',
                        marginBottom: '1rem',
                        borderRadius: '.25rem',
                        border: '1px solid #ced4da',
                        boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                      }}
                      onChange={(e) => { setEmailReset(e.target.value) }}
                    />
                    <button
                      style={{
                        color: '#fff',
                        backgroundColor: '#007bff',
                        borderColor: '#007bff',
                        borderRadius: '.25rem',
                        boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                      }}
                      onClick={ResetPassword}
                    >{i18n.t("SendPassword")}</button>
                  </div>

                )
                :
                (
                  // true stary
                  // false nowy
                  false ?
                    (
                      // stary system logowania
                      <form id='login' action='https://ddp.systems/login/extended' method='post'
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '370px',
                          margin: 'auto',
                        }}
                      >
                        <input type='hidden' name='code' value={code} />
                        <input type='text' name='email' id='email' placeholder={`${i18n.t("Email")}`}
                          style={{
                            height: 'calc(1.5em + .75rem + 2px)',
                            padding: '.375rem .75rem',
                            marginTop: '2.5rem',
                            marginBottom: '1rem',
                            borderRadius: '.25rem',
                            border: '1px solid #ced4da',
                            boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                          }}
                        />
                        <input type='password' name='password' id='password' placeholder={`${i18n.t("Password")}`}
                          style={{
                            height: 'calc(1.5em + .75rem + 2px)',
                            padding: '.375rem .75rem',
                            marginBottom: '1rem',
                            borderRadius: '.25rem',
                            border: '1px solid #ced4da',
                            boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                          }}
                        />
                        <button type='submit' name='submit'
                          style={{
                            color: '#fff',
                            backgroundColor: '#007bff',
                            borderColor: '#007bff',
                            borderRadius: '.25rem',
                            boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                          }}
                        >Submit</button>
                      </form>
                    )
                    :
                    // nowy system logowania
                    (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '370px',
                          margin: 'auto',
                        }}
                      >
                        {/* {Message !== '' ? <p style={{ textAlign: 'center', margin: '0px', color: 'red', marginTop: '10px'}}>{ Message }</p> : null} */}
                        <input type='email' name='email' placeholder={`${i18n.t("Email")}`}
                          style={{
                            height: 'calc(1.5em + .75rem + 2px)',
                            padding: '.375rem .75rem',
                            marginTop: '2.5rem',
                            marginBottom: '1rem',
                            borderRadius: '.25rem',
                            border: '1px solid #ced4da',
                            boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                          }}
                          onChange={(e) => { setEmail(e.target.value) }}
                        />
                        <input type='password' name='password' placeholder={`${i18n.t("Password")}`}
                          style={{
                            height: 'calc(1.5em + .75rem + 2px)',
                            padding: '.375rem .75rem',
                            marginTop: '1rem',
                            marginBottom: '1rem',
                            borderRadius: '.25rem',
                            border: '1px solid #ced4da',
                            boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                          }}
                          onChange={(e) => { setPassword(e.target.value) }}
                        />
                        <button
                          style={{
                            color: '#fff',
                            backgroundColor: '#007bff',
                            borderColor: '#007bff',
                            borderRadius: '.25rem',
                            boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 10px 0px',
                          }}
                          onClick={Login}
                        >{i18n.t("Login")}</button>
                      </div>
                    )
                )

            }


            {/* <form
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '370px',
                    margin: 'auto',
                    marginTop: '1rem',
                    alignItems: 'center',
                  }}
              >
                  <input type='checkbox'/>
                  <label 
                    style={{
                      margin: '0',
                      marginLeft: '1rem'
                    }}
                  >Remember me</label>
              </form> */}

            {/* <Button
                style={{ boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.2)" }}
                block
                variant="primary"
                //type="submit"
                onClick = {test}
                
              >
                {i18n.t("submit")}
              </Button> */}
          </Col>
        </Row>
        <Row
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
          className="mt-3"
        >
          <Col xs={12} md={12} lg={6}>
            {/* <Form.Group controlId="formBasicCheckbox">
                <Form.Check type="checkbox" label="Remember me" />
              </Form.Group> */}
          </Col>
        </Row>
        {/* </Form> */}
      </Col>
      <Col xs={12} md={12} lg={12} className="text-center mb-4">

        <p style={{ cursor: 'pointer' }} onClick={() => { setMessage(''); setForgotPasswd(!ForgotPasswd) }}>{ForgotPasswd ? i18n.t("GoBack") : i18n.t("ResetPassword")}</p>
      </Col>
    </Row>
  );
};
